module.exports = __webpack_public_path__ + "63d152e1.png";